import React from 'react'
import { CreditCardRegistration } from '@/presentation/pages/CreditCardRegistration'
import { NavigationPagesProps } from '@/presentation/components'
import { makeSaveCreditCardByToken } from '@/main/factories/usecases'

export const makeCreditCardRegistrationFactory = ({ navigation }: NavigationPagesProps): JSX.Element => {
  return (
    <CreditCardRegistration
      navigation={navigation}
      saveCardByToken={makeSaveCreditCardByToken()}
    />
  )
}
